import { CustomerPowerSchedulesPage } from '~pages/[organization]/customers/[handle]/powerSchedules';
import { PowerScheduleDetailsPage } from '~pages/[organization]/customers/[handle]/powerSchedules/[id]';
import { PowerScheduleNotFoundPage } from '~pages/[organization]/customers/[handle]/powerSchedules/404';
import { useFeatureFlag } from '~utils/features';
import { ScheduleDetailsPage } from './[id]';
import { ScheduleNotFoundPage } from './404';
import { CustomerSchedulesPage } from './index';

/**
 * The `schedules` routes serve two independent implementations behind one URL.
 *
 * Staff get the new scheduler, which talks to the `schedule*` queries and mutations.
 * Everyone else keeps the power schedule UI on the `powerSchedule*` queries and
 * mutations. The API only answers the new operations for Staff, so this flag has to
 * agree with `userHasStaffFeatureAccess` on the API side.
 */
export function SchedulesIndexRoute() {
  const { isEnabled } = useFeatureFlag('schedules');

  return isEnabled ? <CustomerSchedulesPage /> : <CustomerPowerSchedulesPage />;
}

export function SchedulesDetailRoute() {
  const { isEnabled } = useFeatureFlag('schedules');

  return isEnabled ? <ScheduleDetailsPage /> : <PowerScheduleDetailsPage />;
}

export function SchedulesNotFoundRoute() {
  const { isEnabled } = useFeatureFlag('schedules');

  return isEnabled ? <ScheduleNotFoundPage /> : <PowerScheduleNotFoundPage />;
}
